import gql from 'graphql-tag'

export const userDeviceAccessDelete = gql`
  mutation userDeviceAccessDelete($deviceId: ID!, $userId: ID!) {
    userDeviceAccessDelete(input: { deviceId: $deviceId, userIdToRemove: $userId }) {
      success
    }
  }
`
